import {ApplicationState} from '../../redux/state';
import { connect } from 'react-redux';
import { updateInputData } from '../../redux/product/productActions';
import {  Dispatch } from "redux";
import HubCValue from './HubCValue';

const mapStateToProps = ({product}: ApplicationState) => {
    return {
        c_VALUES: product.currentProduct.c_VALUES,
        c_value: product.productInputData.c_value,
        errorFields: product.productInputData.errorFields,
    };
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
    inputChanged:(productInputData: any) => dispatch(updateInputData(productInputData))
});


const ConnectedHubCValue = connect(
    mapStateToProps,
    mapDispatchToProps
)(HubCValue);

export default ConnectedHubCValue;


